import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import queryString from 'query-string';

import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, Divider, message, Popconfirm } from 'antd';
import { Text } from 'components';

import { DELETE_EVENT } from 'graphql/mutations';
import { GET_EVENTS } from 'graphql/queries';

type Props = {
  id: string;
} & RouteComponentProps;

const Actions: React.FC<Props> = ({ id, history, location }) => {
  const { pathname, search } = location;
  const query = queryString.parse(search);
  const [deleteEvent] = useMutation(DELETE_EVENT, {
    refetchQueries: [{ query: GET_EVENTS, variables: { filter: {} } }]
  });

  const handleConfirm = async (): Promise<void> => {
    try {
      await deleteEvent({ variables: { id } });
      message.success('Activity deleted');
    } catch (err) {
      message.error(err.message);
    }
  };

  return (
    <>
      <Button
        type="link"
        onClick={(): void => {
          history.push({
            pathname,
            search: queryString.stringify({
              ...query,
              a: true,
              id
            })
          });
        }}
      >
        Edit
      </Button>
      <Divider type="vertical" />
      <Popconfirm
        cancelText="No"
        onConfirm={handleConfirm}
        okText="Yes"
        placement="top"
        title="Delete activity?"
      >
        <Text type="danger" style={{ cursor: 'pointer' }}>
          Delete
        </Text>
      </Popconfirm>
    </>
  );
};

export default withRouter(Actions);
